import ArrowIcon from "./ArrowIcon";

const sanitizeHref = (href) => {
  if (!href) return undefined;
  const lower = href.toLowerCase().trimStart();
  // eslint-disable-next-line no-script-url
  const blocked = ["javascript:", "data:", "vbscript:"];
  if (blocked.some((p) => lower.startsWith(p))) return "#";
  return href;
};

const Button = ({
  children,
  href,
  variant = "primary",
  showArrow = true,
  className = "",
  ...props
}) => {
  const Component = href ? "a" : "button";
  const buttonClassName = variant === "ghost" ? "btn-ghost" : "btn-primary";
  const safeHref = sanitizeHref(href);

  return (
    <Component
      href={safeHref}
      className={`${buttonClassName} ${className}`}
      {...props}
    >
      <span>{children}</span>
      {showArrow && <ArrowIcon />}
    </Component>
  );
};

export default Button;
